import { api } from "@/lib/api";

export function fmtTime(sec) {
  const s = Math.max(0, Math.round(Number(sec) || 0));
  const m = Math.floor(s / 60);
  return `${m}:${String(s % 60).padStart(2, "0")}`;
}

export async function pollJob(jobId, onTick) {
  for (;;) {
    await new Promise((r) => setTimeout(r, 2000));
    const { data } = await api.get(`/snippets/jobs/${jobId}`);
    if (onTick) onTick(data);
    if (data.status === "done") return data;
    if (data.status === "error") throw new Error(data.error || "Job failed");
  }
}

export const FORMAT_LABEL = {
  vertical: "9:16 Vertical",
  square: "1:1 Square",
  wide: "16:9 Wide",
};
